import { render, staticRenderFns } from "./verified.vue?vue&type=template&id=f121186a&scoped=true&"
import script from "./verified.vue?vue&type=script&lang=js&"
export * from "./verified.vue?vue&type=script&lang=js&"
import style0 from "./verified.vue?vue&type=style&index=0&id=f121186a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f121186a",
  null
  
)

export default component.exports